import React, { useLayoutEffect, useRef } from 'react';
import { cn } from '@/lib/utils';
import { animateEventEntry } from './helpers/event-entry-animation';

interface EntryRowProps {
  isEntering: boolean;
  className?: string;
  children: React.ReactNode;
}

export function EntryRow({ isEntering, className, children }: EntryRowProps) {
  const rowRef = useRef<HTMLDivElement>(null);

  useLayoutEffect(() => {
    if (!isEntering || !rowRef.current) return;
    return animateEventEntry(rowRef.current);
    // The entry plays once, when the row first mounts.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div ref={rowRef} className={cn('relative', className)}>
      <span
        data-entry-accent
        aria-hidden='true'
        className='pointer-events-none absolute left-0 top-1.5 bottom-1.5 w-0.5 rounded-sm bg-primary opacity-0'
      />
      {children}
    </div>
  );
}
